import { render, staticRenderFns } from "./affiliateModal.vue?vue&type=template&id=518914b4&scoped=true&"
import script from "./affiliateModal.vue?vue&type=script&lang=js&"
export * from "./affiliateModal.vue?vue&type=script&lang=js&"
import style0 from "./affiliateModal.vue?vue&type=style&index=0&id=518914b4&prod&scoped=true&lang=css&"
import style1 from "./affiliateModal.vue?vue&type=style&index=1&id=518914b4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518914b4",
  null
  
)

export default component.exports